const { connect } = require("react-redux");
const { push: Push } = require("react-router-redux");
const CheckoutActions = require("actions/checkout");
const CroquisActions = require("actions/croquis");
const DialogActions = require("actions/dialog");
const SnackbarActions = require("actions/snackbar");
const TransactionDialog = require("components/Dialog/TransactionDialog");

const internals = {};

internals.transactionAction = (transaction, selectedDownloadPackageId) => {
    switch (transaction.type) {
        case "purchase":
            return CroquisActions.purchaseCroquis(
                transaction.id,
                selectedDownloadPackageId
            );
        case "upgrade":
            return CroquisActions.upgradePurchase(
                transaction.id,
                selectedDownloadPackageId
            );
        case "credits":
            return SnackbarActions.messageSnackbar("Successful payment!");
        default:
            // TODO What happens when this occurs?
            throw new Error("Invalid transaction type specified!");
    }
};

internals.connect = connect(
    state => ({
        // key ensures that TransactionDialog rerenders dependent on transaction set in state
        // we include model id in key where applicable
        key:
            state.checkout.transaction &&
            `${state.checkout.transaction.type}${state.checkout.transaction
                .id || ""}`,
        dialogOpen: state.dialog.isTransactionDialogOpen,
        downloadPackages: state.checkout.downloadPackages.dict,
        packageNames: state.checkout.downloadPackages.byName,
        numCredits:
            state.auth.credentials.user && state.auth.credentials.user.credits,
        paymentOptions: state.checkout.paymentOptions,
        receipt: state.checkout.receipt,
        selectedPaymentOptionId: state.checkout.selectedPaymentOptionId,
        selectedDownloadPackageId: state.checkout.selectedDownloadPackageId,
        transaction: state.checkout.transaction
    }),
    {
        displayError: SnackbarActions.messageSnackbar,
        onDownloadPackageSelected: CheckoutActions.selectDownloadPackage,
        onPaymentOptionSelected: CheckoutActions.selectPaymentOption,
        onCheckoutFormSubmit: (token, promoCode) => {
            return (dispatch, getState) => {
                const {
                    selectedDownloadPackageId,
                    selectedPaymentOptionId,
                    transaction
                } = getState().checkout;

                return dispatch(
                    CheckoutActions.purchaseOption(
                        token,
                        selectedPaymentOptionId,
                        promoCode
                    )
                ).then(() => {
                    return dispatch(
                        internals.transactionAction(
                            transaction,
                            selectedDownloadPackageId
                        )
                    );
                });
            };
        },
        onRequestDialogClose: () => {
            return dispatch => {
                dispatch(DialogActions.closeTransactionDialog());
                // We expect this to trigger a component unmount by nulling the transaction segment of redux state
                dispatch(CheckoutActions.endTransaction());
            };
        },
        // Only ever exposed in UI for model transactions (upgrades and purchases)
        onReceiptSuccessButtonClick: () => {
            return (dispatch, getState) => {
                const state = getState();

                dispatch(DialogActions.closeTransactionDialog());
                // We expect this to trigger a component unmount by nulling the transaction segment of redux state
                dispatch(CheckoutActions.endTransaction());
                dispatch(
                    Push(
                        `/purchased-body-model/${state.checkout.receipt.purchased_id}`
                    )
                );
            };
        },
        onRedeemFormSubmit: () => {
            return (dispatch, getState) => {
                const {
                    selectedDownloadPackageId,
                    transaction
                } = getState().checkout;
                return dispatch(
                    internals.transactionAction(
                        transaction,
                        selectedDownloadPackageId
                    )
                ).then(({ data: purchase }) => {
                    dispatch(DialogActions.closeTransactionDialog());
                    // We expect this to trigger a component unmount by nulling the transaction segment of redux state
                    dispatch(CheckoutActions.endTransaction());
                    dispatch(Push(`/purchased-body-model/${purchase.id}`));
                });
            };
        }
    }
);

module.exports = internals.connect(TransactionDialog);



// WEBPACK FOOTER //
// ./src/containers/TransactionDialog.js